<template>
<div class="col-12 text-left">
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint Investigation Answer Form</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="name" v-model="ccu.complaintNo" disabled>
            </div>
            <!-- <div v-if="this.ccu.attachment !== ''" class="form-group col-3">
               <a :href="this.ccu.attachment" class="badge badge-primary">Download Attachment</a>
            </div> -->
            <div class="form-group col-3">
               <label for="module">Please Submit your Investigation</label>
                <app-uploader :fileUrl="ccu.attachment" :fieldName="'attachment'" v-on:finishUpload="finishUpload(...arguments)"></app-uploader>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Question</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccu.question" rows="2" disabled></textarea>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-6">
                <label for="module">Answer</label>
                <textarea class="form-control" id="desc-textarea" v-model="ccu.answer" rows="2"></textarea>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintUser } from '../../models/customerComplaintUser'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppUploader
    },
    data() {
        return {
            ccu: {...customerComplaintUser},
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ccuApi = api('customer-complaint-investigation-answer')
            this.ccu = await ccuApi.getWithParams(this.$route.query.id)
        }
        console.log(this.ccu)
    },
    methods: {
        async save() {
            const ccuApi = api('customer-complaint-investigation-answer')
            if(this.$route.query.id !== undefined) {
                await ccuApi.update(this.ccu, this.$route.query.id)
            } else {
                await ccuApi.create(this.ccu)
                
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            // this.$router.go(-1)
        },
        finishLookup(data) {
            const currentccu = this.ccu
            this.ccu = {
                ...currentccu,
                ...data
            }
        },
        finishUpload(data) {
            const currentccu = this.ccu
            this.ccu = {
                ...currentccu,
                ...data
            }
        },
    }
}
</script>